module.exports = __webpack_public_path__ + "img/Sunlei_Outstanding_Postdoctoral_Fellow.6004af87.png";